<template>
  <div class="content">
    <div class="set-data" v-if="set_data.total">
      Showing {{ set_data.showing }} of {{set_data.total}}
    </div>

    <Edit v-if="$route.params.ids" :fields="fields" />

    <table class="table table-clean table">
        <thead>
          <tr>
            <th>
              <div class="cbox">
								<!-- <label  v-bind:for="`chk_all`">
                  <input type="checkbox" v-bind:id="`chk_all`">
                </label> -->
								<span>&nbsp;</span>
							</div>
            </th>
            <th v-for="f in item_fields" 
				v-if="Data.fieldReadable(f.id, Data) && !f.specific_categories" 
				:key="f.name">
				<span @click="setOrder(f.name)" :class="allowed_orderbys.includes(f.name) ? 'orderby' : ''">
					{{f.label}}
					<i v-if="order.by == f.name && order.isDESC">&#9660;</i>
					<i v-if="order.by == f.name && !order.isDESC">&#9650;</i>					
				</span>
			</th>
			
			<th v-if="current_editor.value == 'specifics'">
				<span>Specifics</span>
			</th>
			
            <th><span>&nbsp;</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" v-bind:key="item.id" :ref="`item_${item.id}`">
            <td>
              <div class="cbox">
				<label  v-bind:for="`chk${item.id}`">
                  <input type="checkbox" tabindex="-1" v-bind:id="`chk${item.id}`" v-on:click="selectedLine(item.id)">
                </label>
			  </div>
            </td>
            <td v-for="field in item_fields" v-if="Data.fieldReadable(field.id, Data) && !field.specific_categories" :key="field.name">
              <Category v-if="field.type == 'tree'" style="width:250px" v-bind:field="field" v-bind:item="[item]" />
              <Select v-else-if="field.type == 'select'" v-bind:field="field" v-bind:item="[item]" />
              <SwitchInput v-else-if="field.type == 'switch'" v-bind:field="field" v-bind:item="[item]" view="inline" />
              <ImageInput v-else-if="field.type == 'image'" v-bind:field="field" v-bind:item="[item]" view="inline" />
              <DynamicInput v-else v-bind:item="[item]" v-bind:field="field" view="inline" />
            </td>
			
			<td v-if="current_editor.value == 'specifics'" class="specifics">
				
				<Specifics v-bind:item="[item]" />
				
			</td>
			
            <td>
              <div class="go-edit">
                <router-link
                  :to="{ path: `/items/edit/${item.id}`}"
                  tag="button"
                  tabindex="-1"
                  class="btn btn-1">
                  <i class="fas fa-angle-right"></i>
                </router-link>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <infinite-loading v-bind:forceUseInfiniteWrapper="true" v-bind:identifier="reset_list" @infinite="infiniteHandler">
        <div slot="no-more">End.</div>
      </infinite-loading>
  </div>
</template>
<script>
import DynamicInput from './input.vue';
import Category from './category.vue';
import Specifics from './specifics.vue';
import Select from './select.vue';
import SwitchInput from './switch.vue';
import ImageInput from './image.vue';
import InfiniteLoading from 'vue-infinite-loading';
import Edit from './edit.vue';
import _ from 'lodash';
import { global_emits } from '../../main';
import Data from  '../../main';
export default {
	name: 'Editor',
	props: {
		type: Object,
		search: String,
		fields: Array,
	},
	data() {		
		return {
			page: 1,
			items: [],
			selected_items: [],
			current_editor: this.type,
			item_fields: [],
			set_data: {},
			reset_list: 0,
			order: {
				by: 'updated_at',
				isDESC: true,
				click_count: 0
			},
			allowed_orderbys: [
				'active',
				'id',
				'title',
				'name',
				'sku',
				'weight',
				'price',
				'price_uk',
				'manufacturer',
				'note',
				'category'
			]
		};
	},
	watch: {
		item: function() {
			this.itemdata = this.item;
			this.items = [];
		},
		type: function() {
			this.current_editor = this.type;
			this.item_fields = this.fields.filter( (f) => f.editors.includes(this.type.value) );
		},
		fields: function() {
			this.item_fields = this.fields.filter( (f) => f.editors.includes(this.type.value) );
		},
		search: function() {
			// reset on search
			this.reset_list++;
			this.page = 1;
			this.items = [];
		},
	},
	computed: {
		Data() {
			return Data;
		},
	},
	mounted() {

	    // update field value on edit page save
	    // global_emits.$on('item_updated', (updated) => {
	    //   this.items.forEach((item, k) => {
	    //     if(item.id == parseInt( updated.ids )){
	    //       updated.data.forEach( i => {
			//
	    //         //categories need labels too
	    //         if(i.name == 'category'){
	    //           this.items[k].category.id = i.value;
	    //           this.items[k].category.label = i.label;
			// 				}else if(i.name == 'image'){
			// 					this.items[k].image = [i.value.image, ...this.items[k].image]
			//
			//
	    //         }else if(i.model){
			// 					this.items[k][i.model][i.name] = i.value;
	    //       	}else{
			// 					this.items[k][i.name] = i.value;
			// 				}
	    //       });
	    //     }
	    //   });
	    // });
	
	    // remove item from list when deleted
	    global_emits.$on('item_deleted', (deleted) => {
	      let toRemove = deleted.ids.split(',');
	      toRemove = toRemove.map(id => {
	          return parseInt(id);
	      });
	
	      this.items = this.items.filter(function(item, i){
	          return !toRemove.includes(item.id);
	      });
	    });
	
	
	    // add item when created
	    global_emits.$on('item_created', (created) => {
	       this.items.unshift(created.item);
	    });

	},
	methods: {
		
		setOrder( field_name ){
			if(  !this.allowed_orderbys.includes(field_name) ) return;
			
			if( field_name != this.order.by )
				this.order.isDESC = false;
			else
				this.order.isDESC = !this.order.isDESC;
			
			if(this.order.by == field_name)
				this.order.click_count++;
			
			this.order.by = field_name;
			
			// reset to default order when any column th clicked 3 times
			if(this.order.click_count == 2){
				this.order.click_count = 0;
				this.order.by = 'updated_at';
				this.order.isDESC = true;
			}
						
			// reset on order change
			this.reset_list++;
			this.page = 1;
			this.items = [];
					
		},
		
		specCategory( item, field ){
	
			if( field.specific_categories && 
				field.specific_categories.split(',').includes(item.category.id.toString()) )
				return true;
			else
				return false;	
		},
		
				
		sortSpecifics(){
			
			this.items.forEach( (i) => {
			
				i.field_specifics.map((fs) => {
									
					fs.item_specifics = i.item_specifics.find((is) => {
						return is.specific_id == fs.id;	
					});
					
					if(fs.item_specifics)
						fs.item_specifics = fs.item_specifics.value;
					
					return fs;
				});
			
			} )
						
		},

		infiniteHandler($state) {
			this.$axios.get('/item', {
				params: {
					page: this.page,
					query: this.$route.query.s,
					orderBy: this.order.by,
					orderDesc: this.order.isDESC ? 'DESC' : 'ASC'
				},
			}).then(({data}) => {				
				if (data.data.length) {
					this.set_data.total = data.total;
					this.set_data.showing = data.per_page * this.page;
					this.set_data.showing = this.set_data.showing > data.total ? data.total : this.set_data.showing;

					this.page += 1;
					this.items.push(...data.data);
					
					this.sortSpecifics();
					$state.loaded();
				} else {
					$state.complete();
				}
			});
		},

		selectedLine( id ) {
			this.$refs[`item_${id}`][0].classList.toggle('highlighted');
			this.selected_items = _.xor(this.selected_items, [id]);
			this.$emit('selectTrigger', this.selected_items);
		},
	},

	components: {
		DynamicInput,
		ImageInput,
		InfiniteLoading,
		Category,
		Specifics,
    	Select,
		SwitchInput,
		Edit,
	},
};
</script>

<style scoped lang="less">

span i{
	font-style: normal;
}

table{
  font-size: 11px;
  font-family: Verdana;
}

.table-clean thead tr th{
	position: sticky;
	top: 0;
	z-index: 2;
	background: #f4f8fb;
	padding:0;
	span{
		border-left: 1px solid #e6e6e6;
		border-bottom: 1px solid #e6e6e6;
		margin-bottom: -1px;
		padding: 10px 4px;
		display: block;
	}
}

.table-clean tbody tr td{
  height: 1px;
  padding: 0;
  border: 1px solid #edf4f8;
}
.cbox,label{
  width: 100%;
  height: 100%;
  padding:0 5px;
  text-align: center;
  cursor: pointer;
  vertical-align: middle;
}
.cbox input{
  cursor: pointer;
  height: 100%;
}
.highlighted{
  background: #cfdfff !important;
}


.go-edit, .go-edit button{
  height: 100%;
  width: 100%;
  border-radius: 0;
  text-align: center;
  border:0;
}
.go-edit button{
  padding: 0 15px;
}

.set-data{
  padding: 5px 25px;
  position: fixed;
  bottom: -1px;
  right: 25px;
  border: 1px solid #ccc;
  z-index: 1;
  background: #fff;
}

.orderby{
	cursor:pointer;
}

</style>
